import { get } from "../index";

export const getDocByID = (id) => {
  return get(`/doc-control/${id}`);
};
